import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import "moment-timezone";
import 'tails-ui/dist/index.css';
import DataTable from 'react-data-table-component';
import orderBy from 'lodash/orderBy';
const useStyles = makeStyles(theme => ({
    icon: {
        marginRight: theme.spacing(2)
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6)
    },
    heroButtons: {
        marginTop: theme.spacing(4)
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8)
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    cardMedia: {
        paddingTop: "56.25%" // 16:9
    },
    cardContent: {
        flexGrow: 1
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6)
    },
    paperLeft: {
        width: "25%",
        float: "left",
        padding: "25px",
        marginRight: "25px"
    },
    paperRight: {
        width: "65%",
        float: "left",
        padding: "25px"
    }
}));



export default function UsersViews(props) {
    const classes = useStyles();
    const userRole = localStorage.getItem("userRole");
    const userId = localStorage.getItem("userId");
    let filterUserData;
    if ('1' === userRole) {
        filterUserData = props.userData && props.userData.filter(user => user.id != userId)
    } else {
        filterUserData = props.userData;
    }
    const columns = [
        {
            name: 'First Name',
            selector: 'user_first',
            sortable: true,
            center: true,
        },
        {
            name: 'Last Name',
            selector: 'user_last',
            sortable: true,
            center: true,
        },
        {
            name: 'Username',
            selector: 'user_login',
            sortable: true,
            center: true,
        },
        {
            name: 'Email',
            selector: 'email',
            sortable: true,
            center: true,
        },
        {
            name: 'Role',
            selector: 'roles',
            sortable: true,
            center: true,
        },
        {
            name: 'Cost Type',
            selector: 'cost_type',
            sortable: true,
            center: true,
        },
        {
            name: 'Vendor Display Name',
            selector: 'code',
            sortable: true,
            center: true,
        },
        {
            name: 'Action',
            selector: 'action',
            sortable: false,
            center: true,
            cell: row => <div className="button-wrap">
                <button onClick={props.handleInpersonate} id={row.id} data-impersonation="true"
                    className="markdown-body jss2258" title="Impersonation">
                    <svg className="MuiSvgIcon-root jss2259" focusable="false" viewBox="0 0 24 24" aria-hidden="true"
                        role="presentation" tabIndex="-1" title="Impersonation">
                        <path fill="#DF6600"
                            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path>
                    </svg>
                    <p>Impersonation</p>
                </button>
                <button onClick={props.handleEditUser}
                    className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit" tabIndex="0"
                    type="button" title="Edit" id={row.id}><span className="MuiIconButton-label"><span
                        className="material-icons MuiIcon-root" aria-hidden="true">edit</span></span><span
                            className="MuiTouchRipple-root"></span></button>
                <button onClick={props.handleDeleteUser}
                    className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit" tabIndex="0"
                    type="button" title="Delete" id={row.id}><span className="MuiIconButton-label"><span
                        className="material-icons MuiIcon-root" aria-hidden="true">delete_outline</span></span><span
                            className="MuiTouchRipple-root"></span></button>
            </div>,
        }
    ];

    const customSort = (rows, field, direction) => {
        const handleField = row => {
            if (row[field]) {
                return row[field].toLowerCase();
            }

            return row[field];
        };

        return orderBy(rows, handleField, direction);
    };

    return (
        <React.Fragment>
            <main>
                <div className="w-full mb-3 mx-auto flex flex-wrap items-center mt-0 p-6">
                    <div className="login-user m-3 float-right w-full">
                        <a href="#" onClick={props.handleAddUser}>
                            <button
                                className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit float-right"
                                tabIndex="0" type="button" title="Add New User">
                                <span className="MuiIconButton-label">
                                    <span className="material-icons MuiIcon-root" aria-hidden="true" style={{ fontSize: '48px', marginRight: '50px' }}>add_box</span>
                                </span>
                                <span className="MuiTouchRipple-root"></span>
                            </button>
                        </a>
                    </div>
                    <DataTable
                        title="Users"
                        columns={columns}
                        data={filterUserData}
                        progressPending={props.userLoading}
                        pagination={true}
                        paginationTotalRows={props.userRows - 1}
                        sortFunction={customSort}
                    />
                </div>
            </main>
        </React.Fragment>
    );
}
